(() => {
  let splitting = false;

  const uid = () => `${Date.now()}-${Math.random().toString(16).slice(2)}`;

  const postFormData = async (url, formData) => {
    const res = await fetch(url, {
      method: "POST",
      headers: { "X-Requested-With": "XMLHttpRequest" },
      body: formData,
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  };

  const getCartContainer = () =>
    document.querySelector("cart-drawer") ||
    document.querySelector("cart-notification") ||
    document.querySelector("cart-items");

  const addSectionsPayload = (formData) => {
    const container = getCartContainer();
    if (container && typeof container.getSectionsToRender === "function") {
      const ids = container.getSectionsToRender().map((s) => s.id);
      formData.set("sections", ids);
      formData.set("sections_url", window.location.pathname);
    }
  };

  const renderCart = (json) => {
    const drawer = document.querySelector("cart-drawer");
    const note = document.querySelector("cart-notification");
    const cartItems = document.querySelector("cart-items");

    if (drawer && typeof drawer.renderContents === "function") {
      drawer.renderContents(json);
      drawer.open?.();
      return;
    }

    if (note && typeof note.renderContents === "function") {
      note.renderContents(json);
      return;
    }

    if (cartItems && typeof cartItems.renderContents === "function") {
      cartItems.renderContents(json);
      return;
    }

    // fallback
    window.location.reload();
  };

  const fetchCart = async () => {
    const res = await fetch("/cart.js", {
      headers: { "X-Requested-With": "XMLHttpRequest" },
    });
    if (!res.ok) throw new Error(await res.text());
    return res.json();
  };

  const isRingItem = (item) => {
    const type = (item.product_type || "").toLowerCase();
    const handle = (item.handle || "").toLowerCase();

    // Adjust these if you want stricter matching:
    // - product_type === 'Ring' is best if you have it set
    // - handle contains 'ring' is a decent fallback
    return type === "ring" || handle.includes("ring");
  };

  const splitLineIfNeeded = async ({ line, desiredQty }) => {
    if (desiredQty <= 1) return null;

    const cart = await fetchCart();
    const item = cart.items?.[line - 1];
    if (!item) return null;

    if (!isRingItem(item)) return null;

    // Build base properties from existing item (preserve everything except our uid key)
    const baseProps = { ...(item.properties || {}) };
    delete baseProps._ring_uid;

    // 1) Set this line back to qty=1
    {
      const fd = new FormData();
      fd.set("line", String(line));
      fd.set("quantity", "1");
      addSectionsPayload(fd);
      await postFormData(`${window.routes?.cart_change_url || "/cart/change"}.js`, fd);
    }

    // 2) Add (desiredQty - 1) more as separate items with unique UID
    // Only request sections on the LAST add to reduce work
    let lastJson = null;
    const adds = desiredQty - 1;

    for (let i = 0; i < adds; i++) {
      const fd = new FormData();
      fd.set("id", String(item.variant_id));
      fd.set("quantity", "1");

      // Add all existing props back
      Object.entries(baseProps).forEach(([k, v]) => {
        if (v === null || typeof v === "undefined") return;
        fd.set(`properties[${k}]`, String(v));
      });

      // Add our unique uid so Shopify won’t merge
      fd.set("properties[_ring_uid]", uid());

      // Only include sections on the LAST call (so renderCart has sections payload)
      if (i === adds - 1) addSectionsPayload(fd);

      lastJson = await postFormData(`${window.routes?.cart_add_url || "/cart/add"}.js`, fd);
    }

    // Return the last JSON (with sections) so we can render
    return lastJson;
  };

  // Intercept quantity changes BEFORE Dawn cart.js processes them
  document.addEventListener(
    "change",
    async (e) => {
      const input = e.target;
      if (!(input instanceof HTMLInputElement)) return;
      if (!input.matches('input[name="updates[]"]')) return;

      // The line index is stored on the input in your templates
      const line = parseInt(input.dataset.index || "", 10);
      const desiredQty = Math.max(0, parseInt(input.value || "0", 10));

      if (!line || desiredQty <= 1) return;
      if (splitting) return;

      splitting = true;
      try {
        // Stop Dawn’s default cart update for this change; we’ll do our own
        e.preventDefault();
        e.stopImmediatePropagation();

        const lastJson = await splitLineIfNeeded({ line, desiredQty });

        // If it was a ring item and we split, re-render.
        // If not a ring item, allow normal behavior by forcing a reload update.
        if (lastJson) {
          renderCart(lastJson);
        } else {
          // Not a ring — let Dawn handle it by triggering a normal change flow
          // simplest reliable fallback:
          window.location.reload();
        }
      } catch (err) {
        console.error("Ring auto-split failed:", err);
        window.location.reload();
      } finally {
        splitting = false;
      }
    },
    true // capture
  );
})();